"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var react_1 = __importDefault(require("react"));
var List_1 = require("@CommonFrontend/ContentTokens/Models/List");
var Utils_1 = require("Project/QwilrEditor/Utils");
var slate_react_1 = require("slate-react");
var classnames_1 = __importDefault(require("classnames"));
var ListItem_1 = require("@CommonFrontend/ContentTokens/TokenRenderers/ListItem");
var EditorPlaceholder_1 = __importDefault(require("Project/QwilrEditor/Placeholder/EditorPlaceholder"));
var sharedListStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/ListItem.css"));
var StylesContext_1 = require("Project/QwilrEditor/StylesContext");
var textStyles_1 = require("@CommonFrontend/WidgetRegistry/Traits/Styleable/textStyles");
var styles = __importStar(require("./ListItem.css"));
var SlateUtils_1 = require("Project/QwilrEditor/Behaviours/SlateUtils");
var getItemNumber = function (editor, element) {
    var _a;
    var _b;
    var level = element.data.level;
    var offset = 0;
    var el = element;
    while (el) {
        if (el.type !== "listItem" || el.data.listType !== List_1.ListItemType.Number || el.data.level < level) {
            break;
        }
        if (el.data.listType === List_1.ListItemType.Number && el.data.level === level) {
            offset += (_b = el.data.startCounter) !== null && _b !== void 0 ? _b : 1;
        }
        try {
            var previous = (0, Utils_1.getPreviousSiblingBlock)(editor, (0, SlateUtils_1.findPath)(editor, el));
            if (!previous) {
                break;
            }
            _a = __read(previous, 1), el = _a[0];
        }
        catch (_c) {
            break;
        }
    }
    return offset;
};
var LIST_MARGIN_MULTIPLIER = 1.3;
var ListItem = function (_a) {
    var _b;
    var element = _a.element, attributes = _a.attributes, children = _a.children, style = _a.style;
    var editor = (0, slate_react_1.useSlate)();
    var styleContext = (0, StylesContext_1.useStylesContext)();
    var listType = element.data.listType;
    var listLevel = element.data.level;
    return (react_1.default.createElement("li", __assign({}, attributes, { style: __assign(__assign(__assign(__assign({}, attributes.style), { marginLeft: "".concat(LIST_MARGIN_MULTIPLIER * (listLevel - 1), "em") }), (0, textStyles_1.maybeAssignComputedForegroundColor)({
            computeForegroundColor: styleContext.computeForegroundColor,
            foregroundColorVar: sharedListStyles.listItemSharedVars.color,
            foregroundStyle: style,
        })), (0, textStyles_1.maybeAssignComputedForegroundColor)({
            computeForegroundColor: styleContext.computeForegroundColor,
            foregroundColorVar: sharedListStyles.listItemSharedVars.markerColor,
            foregroundStyle: { color: style.markerColor },
        })), className: (0, classnames_1.default)(attributes.className, sharedListStyles.listItem({
            listType: listType === List_1.ListItemType.Bullet ? "unordered" : "ordered",
            level: listLevel % 2 === 0 ? "even" : "odd",
            markerStyle: style.marker,
        }), (_b = {
                unordered: listType === List_1.ListItemType.Bullet,
                ordered: listType === List_1.ListItemType.Number
            },
            _b["level-".concat(listLevel)] = listType === List_1.ListItemType.Bullet,
            _b)) }),
        listType === List_1.ListItemType.Number && (react_1.default.createElement("span", { className: "before", contentEditable: false }, (0, ListItem_1.getDisplayNumber)(getItemNumber(editor, element), listLevel))),
        react_1.default.createElement("span", { className: styles.content },
            react_1.default.createElement(EditorPlaceholder_1.default, { element: element }),
            children)));
};
exports.ListItem = ListItem;
